import React from "react";
import ReactDOM from "react-dom";
import { MemoryRouter as Router, Route, Switch } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import { App as PreferenceApp } from "./preference/containers";
import { App as ComparisonApp } from "./comparison/containers";
import { App as ComparisonNewApp } from "./comparison-new/containers";
import { App as ComparisonPredefinedApp } from "./comparison-predefined/containers";
import registerServiceWorker from "./registerServiceWorker";
import i18n from "./i18n";

ReactDOM.render(
  <I18nextProvider i18n={i18n}>
    <Router initialEntries={[window.location.pathname.replace(/\/$/, "")]}>
      <Switch>
        <Route
          path={"/start-interview/preference/:project/"}
          component={PreferenceApp}
        />
        <Route
          path={"/start-interview/comparison/:project/"}
          component={ComparisonApp}
        />
        <Route
          path={"/start-interview/comparison2/:project/"}
          component={ComparisonNewApp}
        />
        <Route
          path={"/start-interview/comparison3/:project/"}
          component={ComparisonPredefinedApp}
        />
      </Switch>
    </Router>
  </I18nextProvider>,
  document.getElementById("root")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js